import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// A TextField for passwords with an eye button that shows or hides what was typed.
// Every prop is passed straight through to TextField, so id, name, autoComplete,
// validation and handlers behave exactly as they would on a plain password field.
export default function PasswordField({ InputProps, sx, ...props }) {
    const [visible, setVisible] = useState(false);

    return (
        <TextField
            {...props}
            type={visible ? 'text' : 'password'}
            // Edge adds its own reveal (and clear) button to password inputs; hide it
            // so there is only our eye.
            sx={[{ '& input::-ms-reveal, & input::-ms-clear': { display: 'none' } }, ...(Array.isArray(sx) ? sx : [sx])]}
            InputProps={{
                ...InputProps,
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton
                            aria-label={visible ? 'Hide password' : 'Show password'}
                            onClick={() => setVisible((v) => !v)}
                            // Keep focus (and the caret) in the input when clicking the eye.
                            onMouseDown={(e) => e.preventDefault()}
                            edge='end'>
                            {visible ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    );
}
